import { type CoreInsurance } from '@flecto/types'
import { Badge, type BadgeProps } from '@flecto/ui'

import { useBookingInsuranceStatus } from '../../hooks/useBookingInsuranceStatus'

export type BadgeInsuranceStatusProps = BadgeProps & {
  insurance?: CoreInsurance
  withDot?: boolean
}

export function BadgeInsuranceStatus({
  insurance,
  withDot,
  ...props
}: BadgeInsuranceStatusProps) {
  const info = useBookingInsuranceStatus({ insurance })

  if (!insurance) {
    return null
  }

  return (
    <Badge {...props} color={info.color} withDot={withDot}>
      {info.label}
    </Badge>
  )
}
